import type { PropsWithChildren } from 'react';
import React, { createContext, useContext } from 'react';
import type { ExtraConfig } from './context.types';

interface ExtraConfigContext {
	extraConfig: ExtraConfig;
}

const ExtraConfigContext = createContext<ExtraConfigContext | undefined>(
	undefined
);

export const ExtraConfigProvider = ({
	extraConfig,
	children,
}: PropsWithChildren<{ extraConfig: ExtraConfig }>) => (
	<ExtraConfigContext.Provider value={{ extraConfig }}>
		{children}
	</ExtraConfigContext.Provider>
);

export const useExtraConfigContext = () => {
	const context = useContext(ExtraConfigContext);
	if (!context) {
		throw new Error(
			'useExtraConfig must be used within an ExtraConfigProvider'
		);
	}
	return context;
};
